import { buildFetchMutations } from '@/store/extensions/fetch';

export default {
  ...buildFetchMutations(['fetchPayrolls']),
};



// WEBPACK FOOTER //
// ./src/store/modules/payroll/mutations.js